module.exports = __webpack_public_path__ + "static/group-f1df89226acb2950ce81a308efd1792f.png";